import { render, staticRenderFns } from "./contributor.vue?vue&type=template&id=da3f13ea&scoped=true"
import script from "./contributor.vue?vue&type=script&lang=js"
export * from "./contributor.vue?vue&type=script&lang=js"
import style0 from "./contributor.vue?vue&type=style&index=0&id=da3f13ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3f13ea",
  null
  
)

export default component.exports